export default __webpack_public_path__ + "static/media/mango-poly-inst.38eb903d.png";